import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useLang } from "@/lib/lang";

export default function Navbar() {
  const { t, lang, toggle } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  const LINKS = [
    { href: "#about", label: t.nav.about, key: "about" },
    { href: "#framework", label: t.nav.framework, key: "framework" },
    { href: "#services", label: t.nav.services, key: "services" },
    { href: "#book", label: t.nav.book, key: "book" },
  ];

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const LangToggle = () => (
    <button className="lang-toggle" data-testid="lang-toggle" onClick={toggle}
      aria-label="Switch language">
      <span className={lang === "en" ? "on" : ""}>EN</span>
      <span className="sep">/</span>
      <span className={lang === "he" ? "on" : ""}>עב</span>
    </button>
  );

  return (
    <>
      <motion.nav
        className="qs-nav"
        data-testid="navbar"
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <a href="#home" className="logo" data-testid="nav-logo" onClick={(e) => { e.preventDefault(); go("#home"); }}>
          {t.logo}
        </a>

        <div className="nav-links">
          {LINKS.map((l) => (
            <a key={l.key} href={l.href} className="txt" data-testid={`nav-link-${l.key}`}
              onClick={(e) => { e.preventDefault(); go(l.href); }}>
              {l.label}
            </a>
          ))}
          <a href="#contact" className="btn btn-sm" data-testid="nav-contact-btn"
            onClick={(e) => { e.preventDefault(); go("#contact"); }}>
            {t.nav.contact}
          </a>
          <LangToggle />
        </div>

        <div className="nav-mobile-actions">
          <LangToggle />
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
            onClick={() => setOpen((v) => !v)}
            style={{ background: "none", border: "none", color: "#f4f0ea", cursor: "pointer", position: "relative", zIndex: 101 }}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </motion.nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="mobile-menu"
          >
            {[...LINKS, { href: "#contact", label: t.nav.contact, key: "contact" }].map((l) => (
              <a key={l.key} href={l.href} data-testid={`mobile-link-${l.key}`}
                onClick={(e) => { e.preventDefault(); go(l.href); }}
                className="head mobile-menu-link">
                {l.label}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
